<template>
  <div>
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <c-candle v-if="!params.node.group" :open="open" :close="close" :low="low" :high="high" />
  </div>
</template>

<script>
import CCandle from '@custom/CCandle';
import { getAriaText } from '@utils/helpers';

export default {
  name: 'candle-renderer',
  components: {
    CCandle
  },
  data() {
    return {
      open: 0,
      close: 0,
      low: 0,
      high: 0
    };
  },
  mounted() {
    if (this.params.value) {
      this.open = this.params.value.open;
      this.close = this.params.value.close;
      this.low = this.params.value.low;
      this.high = this.params.value.high;
    }
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      if (!this.params.value) return false;
      this.open = params.value.open;
      this.close = params.value.close;
      this.low = params.value.low;
      this.high = params.value.high;
      return true;
    }
  }
};
</script>
